import { type ComponentRef, Directive, input } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import { ParticipantContextMenuComponent } from '../components/participant-context-menu/participant-context-menu.component';
import { type Participant } from '../types/participant';

@Directive({
  selector: '[appParticipantContextMenu]',
  standalone: true,
})
export class ParticipantContextMenuDirective extends ContextMenuDirective {
  public readonly appParticipantContextMenu = input.required<Participant>();
  public readonly appParticipantContextMenuTenantItems = input<ReadonlyArray<{ readonly accountId?: string }> | undefined>();

  /**
   * Controls visibility of contact options in the context menu:
   * - "Add to Contacts" (for auto-generated contacts)
   * - "Open Contact" (for a single linked contact)
   * - "View Contacts" (for multiple linked contacts)
   * Disabled by default.
   */
  public readonly appParticipantContextMenuShowContactOptions = input<boolean>(false);

  registerComponent() {
    return ParticipantContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<ParticipantContextMenuComponent>): void {
    componentRef.instance.participant = this.appParticipantContextMenu();
    const tenantItems = this.appParticipantContextMenuTenantItems();
    if (tenantItems !== undefined) componentRef.instance.tenantItems = tenantItems;
    componentRef.instance.showContactOptions = this.appParticipantContextMenuShowContactOptions();
  }
}
